<mat-accordion>
  <mat-expansion-panel (opened)="enableForm()" (closed)="disableForm()" [expanded]="isUpdater" [hideToggle]="isUpdater">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div>
          <div class="residential-accordion__title">{{'residential.pm_details.title' | translate }}<span *ngIf="!isUpdater">({{  'residential.community_details.optional' | translate }})</span>:</div>
          <div class="residential-accordion__description" *ngIf="!isUpdater">{{'residential.pm_details.description' | translate }}</div>
          <div class="residential-accordion__description" *ngIf="isUpdater">{{'residential.pm_details.description_updater' | translate }}</div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
      <mat-form-field appearance="outline" fxFlex="">
        <mat-label>Entity type</mat-label>
        <mat-select formControlName="entity_type">
          <mat-option value="company">Company</mat-option>
          <mat-option value="person">Person</mat-option>
        </mat-select>
        <mat-error *ngIf="f['entity_type'].errors">
          {{ f['entity_type'] | errorMsg }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="f['entity_type'].value === 'company'">
        <mat-label>Company Name *</mat-label>
        <input matInput type="text" formControlName="company_name">
        <mat-error *ngIf="f['company_name'].errors">
          {{ f['company_name'] | errorMsg }}
        </mat-error>
      </mat-form-field>

      <ng-container *ngIf="f['entity_type'].value === 'person'">
        <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
          <mat-form-field appearance="outline" fxFlex="">
            <mat-label>First Name *</mat-label>
            <input matInput type="text" formControlName="first_name">
            <mat-error *ngIf="f['first_name'].errors">
              {{ f['first_name'] | errorMsg }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="">
            <mat-label>Last Name *</mat-label>
            <input matInput type="text" formControlName="last_name">
            <mat-error *ngIf="f['last_name'].errors">
              {{ f['last_name'] | errorMsg }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-form-field appearance="outline" fxFlex="">
          <mat-label>Email Address *</mat-label>
          <input matInput type="text" formControlName="email_address">
          <mat-error *ngIf="f['email_address'].errors">
            {{ f['email_address'] | errorMsg }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="">
          <mat-label>Phone Number *</mat-label>
          <input matInput mask="(000) 000-0000" minlength="10" type="text" formControlName="phone_number">
          <mat-error *ngIf="f['phone_number'].errors">
            {{ f['phone_number'] | errorMsg: ('residential.contact_phone' | translate) : 'phone' }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-form-field appearance="outline" fxFlex="60%">
          <mat-label>Address *</mat-label>
          <input matInput type="text" formControlName="address">
          <mat-error *ngIf="f['address'].errors">
            {{ f['address'] | errorMsg }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="">
          <mat-label>Address 2</mat-label>
          <input matInput type="text" formControlName="address2">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-form-field fxFlex="" appearance="outline">
          <mat-label>{{ 'residential.city' | translate }} *</mat-label>
          <input matInput type="text" formControlName="city" id="city">
          <mat-error *ngIf="f['city'].errors" class="invalid-input-dedactible">
            {{ f['city'] | errorMsg }}
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="" appearance="outline">
          <mat-label>{{ 'residential.state' | translate }} *</mat-label>
          <mat-select formControlName="state" id="state">
            <mat-option *ngFor="let state of stateList; let i=index;" [value]="state">{{state}}</mat-option>
          </mat-select>
          <mat-error *ngIf="f['state'].errors">
            {{ f['state'] | errorMsg }}
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="" appearance="outline">
          <mat-label>{{ 'residential.postal_code' | translate }} *</mat-label>
          <input matInput type="text" formControlName="postal_code" id="postal_code" mask="00000">
          <mat-error *ngIf="f['postal_code'].errors">
            {{ f['postal_code'] | errorMsg: undefined: 'zip'  }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>
